export function formatNumber(num: number, digits = 0) {
  if (num >= 1e9) return `${(num / 1e9).toFixed(digits)}g`;
  if (num >= 1e6) return `${(num / 1e6).toFixed(digits)}m`;
  if (num >= 1e3) return `${(num / 1e3).toFixed(digits)}k`;
  return num;
}

export const formatNumberWithCommas = (number: number): string =>
  new Intl.NumberFormat('en-US').format(number);
